<h2 mat-dialog-title class="dialog-header">
    <span class="title-large">{{ 'products.ui.aggiungiAlCarrello' | transloco }}</span>

    <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'products.ui.chiudi' | transloco"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="content">
    <div class="selected-article-card">
        <span class="body-medium emphasized selected-article-label">{{ 'products.ui.articoloSelezionato' | transloco }}</span>

        <span class="body-medium emphasized selected-article-name">{{ data.nomeProdotto }}</span>

        @if (data.sku) {
            <span class="body-medium">{{ data.sku }}</span>
        }

        <div class="dialog-row">
            <span class="body-medium">{{ packagingDescription }}</span>

            <div class="quantity-stepper">
                @if (quantity() === 1) {
                    <button
                        matButton="tonal"
                        [attr.aria-label]="(inCart ? 'products.ui.rimuoviDalCarrello' : 'products.ui.annulla') | transloco"
                        class="stepper-button"
                        (click)="onRemove()"
                    >
                        <i class="fa-regular fa-trash-can"></i>
                    </button>
                } @else {
                    <button
                        matButton="tonal"
                        [attr.aria-label]="'products.ui.diminuisciQuantita' | transloco"
                        class="stepper-button"
                        (click)="decrement()"
                    >
                        <i class="fa-regular fa-minus"></i>
                    </button>
                }

                <input
                    class="body-medium emphasized quantity-value"
                    type="number"
                    min="1"
                    [attr.aria-label]="'products.ui.quantita2' | transloco"
                    [value]="quantity()"
                    (change)="onQuantityInput($any($event.target).value)"
                />

                <button
                    matButton="tonal"
                    [attr.aria-label]="'products.ui.aumentaQuantita' | transloco"
                    class="stepper-button"
                    (click)="increment()"
                >
                    <i class="fa-regular fa-plus"></i>
                </button>
            </div>
        </div>

        <div class="dialog-row">
            <span class="body-medium">{{ 'products.ui.prezzoUnitario' | transloco }}</span>

            <mat-form-field appearance="outline" class="price-field" subscriptSizing="dynamic">
                <input
                    matInput
                    type="number"
                    min="0"
                    step="0.0001"
                    [attr.aria-label]="'products.ui.prezzoUnitario' | transloco"
                    [value]="price()"
                    (change)="onPriceInput($any($event.target).value)"
                />
                <span matTextSuffix class="price-suffix">€@if (data.unitaMisura) { / {{ data.unitaMisura }}}</span>
            </mat-form-field>
        </div>

        <prd-price-below-minimum-warning [price]="price()" [minimum]="data.prezzoMinimo" />

        <ng-container *ngComponentOutlet="extra(); inputs: extraInputs()" />
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton="filled" type="button" (click)="onConfirm()">{{ 'products.ui.confermaEAggiungi' | transloco }}</button>
</mat-dialog-actions>
